import { API_BASE_URL } from "../config/api";
import { getSession } from "./authStorage";

export class ApiError extends Error {
  constructor(message, { status, data } = {}) {
    super(message);
    this.name = "ApiError";
    this.status = status;
    this.data = data;
  }
}

function buildHeaders(extraHeaders = {}) {
  const headers = {
    "Content-Type": "application/json",
    ...extraHeaders,
  };

  const session = getSession();
  if (session?.token) {
    headers.Authorization = `Bearer ${session.token}`;
  }
  if (session?.username) {
    headers["x-username"] = session.username;
  }
  if (session?.apiKey) {
    headers["x-api-key"] = session.apiKey;
  }

  return headers;
}

function connectionErrorMessage() {
  return `Cannot reach the server at ${API_BASE_URL}. Check that the backend and Cloudflare tunnel are running, and REACT_APP_API_BASE_URL is set correctly.`;
}

export async function apiPost(path, body, options = {}) {
  const { skipAuth = false } = options;

  let response;
  try {
    response = await fetch(`${API_BASE_URL}${path}`, {
      method: "POST",
      headers: skipAuth
        ? { "Content-Type": "application/json" }
        : buildHeaders(),
      body: JSON.stringify(body),
    });
  } catch {
    throw new ApiError(connectionErrorMessage());
  }

  let data;
  const contentType = response.headers.get("content-type") || "";
  if (contentType.includes("application/json")) {
    try {
      data = await response.json();
    } catch {
      throw new ApiError("Server returned invalid JSON.", { status: response.status });
    }
  } else {
    const text = await response.text();
    data = text || null;
  }

  if (!response.ok) {
    const message =
      (data && data.Error) ||
      (data && data.error) ||
      `Request failed with status ${response.status}.`;
    throw new ApiError(message, { status: response.status, data });
  }

  return data;
}

export async function apiGet(path, options = {}) {
  const { skipAuth = false } = options;

  let response;
  try {
    response = await fetch(`${API_BASE_URL}${path}`, {
      method: "GET",
      headers: skipAuth
        ? { "Content-Type": "application/json" }
        : buildHeaders(),
    });
  } catch {
    throw new ApiError(connectionErrorMessage());
  }

  let data;
  const contentType = response.headers.get("content-type") || "";
  if (contentType.includes("application/json")) {
    try {
      data = await response.json();
    } catch {
      throw new ApiError("Server returned invalid JSON.", { status: response.status });
    }
  } else {
    const text = await response.text();
    data = text || null;
  }

  if (!response.ok) {
    const message =
      (data && data.Error) ||
      (data && data.error) ||
      `Request failed with status ${response.status}.`;
    throw new ApiError(message, { status: response.status, data });
  }

  return data;
}
